import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from "react";
import { extend, useThree, useFrame } from "@react-three/fiber";
import {
  CSS2DRenderer,
  CSS2DObject
} from "three/examples/jsm/renderers/CSS2DRenderer";
import { RENDER_ORDER } from "@graphic/constants";

extend({ CSS2DObject });

const CSS2DSetup = () => {
  // const { scene, camera } = useThree();

  const labelRendererRef = useRef<CSS2DRenderer | null>(null);

  useLayoutEffect(() => {
    const sceneContainer = document.getElementById("scene");

    if (!sceneContainer) return;
    // CSS2DRenderer 인스턴스 생성 및 설정
    const labelRenderer = new CSS2DRenderer();

    labelRenderer.domElement.id = "label-renderer";

    labelRenderer.domElement.style.position = "absolute";
    labelRenderer.domElement.style.top = "0";

    labelRenderer.domElement.style.zIndex = "";

    sceneContainer.appendChild(labelRenderer.domElement);
    labelRendererRef.current = labelRenderer;

    // CSS 규칙을 추가하는 스타일 태그 생성
    const style = document.createElement("style");
    style.innerHTML = `
    #label-renderer {
      pointer-events: none;
    }
    #label-renderer img {
      pointer-events: auto;
    }
  `;
    document.head.appendChild(style);

    const resizeRenderer = () => {
      labelRenderer.setSize(
        sceneContainer.offsetWidth,
        sceneContainer.offsetHeight
      );
    };

    resizeRenderer();
    window.addEventListener("resize", resizeRenderer);

    return () => {
      // 컴포넌트가 언마운트될 때 정리
      window.removeEventListener("resize", resizeRenderer);

      sceneContainer.removeChild(labelRenderer.domElement);
    };
  }, []);

  useFrame(({ scene, camera }) => {
    labelRendererRef.current?.render(scene, camera);
  }, RENDER_ORDER.LABEL_RENDERER);

  return null;
};

export default CSS2DSetup;
